module.exports = "//static.hsappstatic.net/ContentComponents/static-2.69305/img/payment_methods.png"